export const ORDER_UNPAID_ERROR_CODE = 'ORDER_UNPAID';
export const UNPAID_ORDER_NOTICE_EVENT = 'bw:unpaid-order-notice';

const UNPAID_ORDER_MESSAGES = new Set(['đơn hàng chưa thanh toán', 'đơn hàng chưa được thanh toán']);

const normalizeMessage = (value) =>
  `${value || ''}`
    .trim()
    .toLocaleLowerCase('vi-VN')
    .replace(/[.!?]+$/g, '')
    .replace(/\s+/g, ' ');

const getMessageText = (message) => {
  if (typeof message === 'string') return message;
  if (!message || typeof message !== 'object') return '';
  return message.message || message.errmsg || message.errors?.message || '';
};

const getNoticeErrorCode = (message, options = {}) =>
  options.errorCode ||
  options.error_code ||
  options.code ||
  message?.errorCode ||
  message?.error_code ||
  message?.code ||
  message?.errors?.errorCode ||
  message?.errors?.error_code ||
  message?.errors?.code;

export const getOrderIdFromPathname = (pathname = '') => {
  const matched = `${pathname}`.match(/\/orders\/(?:edit|detail|payment)\/([^/?#]+)/i);
  return matched?.[1] ? decodeURIComponent(matched[1]) : null;
};

const getCurrentPathname = () => (typeof window !== 'undefined' ? window.location?.pathname || '' : '');

export const isUnpaidOrderError = (message, options = {}) => {
  if (options.unpaidOrderNotice === false) return false;
  if (`${getNoticeErrorCode(message, options) || ''}`.toUpperCase() === ORDER_UNPAID_ERROR_CODE) return true;

  const normalizedMessage = normalizeMessage(getMessageText(message));
  if (UNPAID_ORDER_MESSAGES.has(normalizedMessage)) return true;

  if (normalizedMessage !== 'chưa thanh toán') return false;
  return Boolean(
    options.unpaidOrderId ||
    message?.order_id ||
    message?.orderId ||
    message?.errors?.order_id ||
    getOrderIdFromPathname(options.pathname ?? getCurrentPathname()),
  );
};

export const resolveUnpaidOrderNotice = (detail = {}) => {
  const orderId =
    detail.orderId ||
    detail.order_id ||
    detail.message?.orderId ||
    detail.message?.order_id ||
    detail.message?.errors?.order_id ||
    getOrderIdFromPathname(detail.pathname ?? getCurrentPathname());

  return {
    orderId: orderId ? `${orderId}` : null,
    paymentPath: orderId ? `/orders/payment/${encodeURIComponent(orderId)}` : null,
  };
};

export const openUnpaidOrderNotice = (detail = {}) => {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return false;

  window.dispatchEvent(
    new CustomEvent(UNPAID_ORDER_NOTICE_EVENT, {
      detail: resolveUnpaidOrderNotice(detail),
    }),
  );
  return true;
};
